import React from "react";
import Card from "../../components/card/Card";
import FormModificaTipoImpExpController from "./components/FormModificaTipoImpExpController";

export default function InserisciTipoImpExpFiglioView({
                                                          id,
                                                          idClasse,
                                                          padre,
                                                          history,
                                                          formikRef,
                                                          bottoniSx,
                                                          bottoniDx,
                                                      }) {

    return (
        <Card
            icon={'fas fa-list'}
            title={"Inserisci tipo imp exp figlio"}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        >
            <FormModificaTipoImpExpController
                id={id}
                idClasse={idClasse}
                history={history}
                formikRef={formikRef}
                principale={true}
                addFiglio={true}
                padre={padre}
            />
        </Card>
    );
}